<template>
  <div>
    <div class="gradient-overlay"></div>

    <div class="fixed-nav">
      <GridBody class="ml-0">
        <div class="flex-between">
          <p class="subtitle is-size-4 mb-4 is-uppercase is-primary">
            {{
              new Date(startDate).toLocaleDateString($i18n.locale, {
                year: "numeric",
                month: "short",
                day: "numeric",
              })
            }}
            —
            {{
              new Date(endDate).toLocaleDateString($i18n.locale, {
                year: "numeric",
                month: "short",
                day: "numeric",
              })
            }}
          </p>
        </div>
        <div class="flex-between">
          <b-button
            :disabled="
              $fetchState.pending || startDate === new Date().toISOString()
            "
            class="is-uppercase is-size-6 primary-btn"
            :icon-left="
              $fetchState.pending
                ? 'fas fa-spinner fa-spin'
                : 'fas fa-calendar-day'
            "
            @click="goToToday"
          >
            {{ $t("events.calendar.todayButton") }}
          </b-button>

          <div class="flex">
            <b-button
              :disabled="
                $fetchState.pending || startDate === new Date().toISOString()
              "
              class="is-uppercase is-size-6 primary-btn"
              :icon-left="
                $fetchState.pending
                  ? 'fas fa-spinner fa-spin'
                  : 'fas fa-arrow-left'
              "
              @click="previousWeek"
            >
            </b-button>

            <b-button
              :disabled="
                $fetchState.pending ||
                endDate ===
                  new Date(
                    new Date().setMonth(new Date().getMonth() + 1)
                  ).toISOString()
              "
              class="is-uppercase is-size-6 primary-btn"
              :icon-left="
                $fetchState.pending
                  ? 'fas fa-spinner fa-spin'
                  : 'fas fa-arrow-right'
              "
              @click="nextWeek"
            >
            </b-button>
          </div>
        </div>
      </GridBody>
    </div>
    <section class="main-content">
      <div
        v-if="!$fetchState.pending && Object.keys(groupedEvents).length === 0"
        class="no-events-label"
      >
        <h2
          class="subtitle is-size-5 is-uppercase has-text-centered has-text-weight-bold is-primary"
        >
          {{ $t("events.noEvents") }}
        </h2>
      </div>
      <div
        v-for="(group, year, i) in groupedEvents"
        :key="i"
        class="calendar-container"
      >
        <div v-for="(months, month, j) in group" :key="j">
          <div v-for="(group, day, k) in months" :key="k">
            <GridBox v-if="!$fetchState.pending && group.length > 0">
              <GridItem size="100%" :colidx="3" class="date-header">
                <GridBody>
                  <h2
                    class="subtitle is-size-5 is-uppercase has-text-weight-bold is-primary-alt"
                  >
                    {{ formatDateHeader(year, month, day) }}
                  </h2>
                </GridBody>
              </GridItem>
            </GridBox>
            <GridBox v-else>
              <GridItem size="100%" :colidx="3" class="date-header">
                <GridBody>
                  <b-skeleton
                    as="div"
                    width="20%"
                    height="1.5rem"
                    animated
                    :count="1"
                  />
                </GridBody>
              </GridItem>
            </GridBox>
            <GridBox>
              <EventCard
                v-for="(event, bindex) in group"
                :loaded="!$fetchState.pending && group.length > 0"
                :key="bindex"
                :event="event"
                :col="computeCol(event)"
                :clickevt="openEvt"
                :seatsOptions="seatsOptions"
                :onReady="onReady"
              />
            </GridBox>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.no-events-label {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  width: 100%;
  .subtitle {
    font-size: 2rem;
    font-weight: 700;
    color: var(--color-primary);
  }
}
.gradient-overlay {
  transition: all 0.2s ease-in-out;
  opacity: 0.5;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  width: 100%;
  overflow: hidden;
  height: 90vh;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(var(--color-primary-alt-rgba), 0.25) 0%,
    rgba(var(--color-primary-alt-rgba), 0) 100%
  );
  /* background: red; */
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  @media (min-width: 960px) {
    max-width: 1280px;
    margin: 0 auto;
  }
}
.button.is-subtle {
  background: transparent !important;
  color: var(--color-primary) !important;
}
.main-content {
  padding-bottom: 5rem;
  max-width: 1280px;
  margin-bottom: 8rem;
  padding: 0 1rem;
}

.fixed-nav {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  bottom: 0;
  left: 0;
  /* margin-bottom: 1rem; */
  position: fixed !important;
  /* width: 100%; */
  z-index: 9;

  background: rgba(var(--bg-secondary-rgba), 0.9);
  backdrop-filter: blur(2rem);
  -webkit-backdrop-filter: blur(2rem);
  .grid-body {
    margin: 0;
  }
  width: 100%;
  button {
    /* width: 100%; */
  }
}

.date-header {
  position: sticky;
  // top: 15rem;
  background: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
  border-left: 1px solid var(--color-primary-alt);
  margin-top: 1rem !important;
  height: auto;
  /* width: 100%; */
  .b-skeleton {
    .b-skeleton-item {
      border-radius: var(--radius-sm) !important;

      background: linear-gradient(
        90deg,
        rgba(var(--bg-secondary-rgba), 1) 25%,
        rgba(var(--color-primary-alt-rgba), 0.15) 50%,
        rgba(var(--color-primary-alt-rgba), 0.4) 60%,
        rgba(var(--bg-secondary-rgba), 1) 75%
      );
      background-size: 400% 100%;
    }
  }
}

.event-color {
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  width: 1.1rem;
  height: 1.1rem;
  margin-right: 0.1rem;
  display: inline-block;
}
.title {
  font-size: 2rem;
  font-weight: 700;
  color: var(--color-primary);
}
.subtitle {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-subtle);
  margin: 0;
}
.hero-body {
  padding-bottom: 0;
}
</style>
<script>
import CalendarNav from "~/components/CalendarNav";
import EventCard from "~/components/EventCard";
import GridBody from "~/components/GridBody";
import GridBox from "~/components/GridBox";
import GridItem from "~/components/GridItem";
import { gql } from "~/utils/gql";

const GET_EVENTS = /* GraphQL */ `
  query getEvents(
    $first: Int
    $skip: Int
    $start_gte: DateTime
    $end_lte: DateTime
  ) {
    allEventi(
      sortBy: start_ASC
      first: $first
      skip: $skip
      where: { start_gte: $start_gte, start_lte: $end_lte, public: true }
    ) {
      id
      title
      start
      end
      summary
      backgroundColor
      link
      urlSlug
      allDay
      recurring
      daysOfWeek
      startRecur
      paid
      price
      currency
      seats
      seatsTaken
      endRecur
      display
      image
      featured
      category {
        name
        nameEn
        value
        id
      }
    }
  }
`;

const GET_EVENTS_COUNT = /* GraphQL */ `
  query eventiCount(
    $first: Int
    $skip: Int
    $start_gte: DateTime
    $end_lte: DateTime
  ) {
    _allEventiMeta(
      sortBy: start_ASC
      first: $first
      skip: $skip
      where: { start_gte: $start_gte, end_lte: $end_lte }
    ) {
      count
    }
  }
`;

export default {
  name: "Events",
  components: {
    GridItem,
    GridBox,
    GridBody,
    CalendarNav,
    EventCard,
    // EventModal,
  },
  layout: "default",

  watch: {
    $route(to, from) {
      this.$store.commit("setCurrPageTitle", this.$t("events.header"));
    },
    // recompute col size on window resize
    // window.innerWidth
    // window.addEventListener("resize", () => {
  },
  data() {
    return {
      pageTitle: "TDF*P — " + this.$t("events.meta.title"),

      isLoadingData: false,
      events: [],
      groupedEvents: {},
      // startdate is current monday, at 00:00:00
      startDate: (() => {
        const today = new Date();
        const day = today.getDay();
        const diff = day === 0 ? -6 : 1 - day; // If Sunday (0), go back 6 days; otherwise go back to Monday
        const monday = new Date(today);
        monday.setDate(today.getDate() + diff);
        monday.setHours(0, 0, 0, 0);
        return monday.toISOString();
      })(),
      // enddate is current sunday, at 23:59:59
      endDate: (() => {
        const today = new Date();
        const day = today.getDay();
        const diff = day === 0 ? 0 : 7 - day; // If Sunday (0), stay; otherwise go forward to Sunday
        const sunday = new Date(today);
        sunday.setDate(today.getDate() + diff);
        sunday.setHours(23, 59, 59, 999);
        return sunday.toISOString();
      })(),
      mobile: this.$store.getters["getIsMobile"],
      // firstVal: 10,
      // skipVal: 0,
      totalEvents: 0,
      seatsOptions: {
        decimalPlaces: 0,
        duration: 0.5,
        useEasing: true,
        useGrouping: true,
        // separator: ",",
        // decimal: ".",
        // prefix: `${this.currency} `,
        suffix: "",
      },
    };
  },
  beforeMount() {},
  mounted() {
    this.$store.commit("setCurrPageTitle", this.$t("events.header"));

    if (!this.$route.query.f) {
      this.$router.replace({
        query: {
          f: new Date(
            new Date().setDate(new Date().getDate() - new Date().getDay() + 1)
          )
            .toISOString()
            .split("T")[0],
        },
      });
    }

    this.enterAnimation();

    this.$fetch();
    if (process.client && window) {
      window.addEventListener("resize", () => {
        this.$forceUpdate();
      });
    }
    // if this.$route.query is not defined, then it's the first time the page is loaded, so we can set the query to the current date
  },
  head() {
    return {
      title: this.pageTitle,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  computed: {},
  async fetch() {
    this.isLoadingData = true;
    if (process.client && window) {
      window.scrollTo(0, 0);
    }

    try {
      let { data } = await gql(GET_EVENTS, {
        // first: this.firstVal,
        // skip: this.skipVal,
        start_gte: this.startDate,
        end_lte: this.endDate,
      });
      let { data: count } = await gql(GET_EVENTS_COUNT, {
        start_gte: this.startDate,
        end_lte: this.endDate,
      });
      if (count && count._allEventiMeta) {
        this.totalEvents = count._allEventiMeta.count;
      }
      if (data && data.allEventi) {
        this.events = [...data.allEventi];
        this.events.forEach((event) => {
          if (event.image) {
            const imageId = event.image.split("/").pop().split(".")[0];
            const cloudinaryId = "dwiebcqwl";
            const actualImage = `https://res.cloudinary.com/${cloudinaryId}/image/upload/c_scale,f_auto,w_200/events/${imageId}.webp`;

            event.image = actualImage;
          } else {
            event.image = null;
          }
          if (!event.featured) {
            event.featured = event.category.value === "events";
          }

          return {
            id: event.id,
            title: event.title,
            start: event.start,
            end: event.end,
            summary: event.summary,
            backgroundColor: event.backgroundColor,

            link: event.link,
            urlSlug: event.urlSlug,
            allDay: event.allDay,
            recurring: event.recurring,
            daysOfWeek: event.daysOfWeek,
            startRecur: event.startRecur,
            endRecur: event.endRecur,
            featured: event.featured,
            // featured: event.featured,
            display: event.display,
            image: event.image,
          };
        });
        // groupedevents is events grouped by year, then by month, then by day
        // the structure is {year: {month: {day: [events]}}}
        this.groupedEvents = this.events.reduce((acc, event) => {
          const date = new Date(event.start);
          const year = date.getFullYear();
          const month = date.getMonth() + 1;
          const day = date.getDate();
          if (!acc[year]) {
            acc[year] = {};
          }
          if (!acc[year][month]) {
            acc[year][month] = {};
          }
          if (!acc[year][month][day]) {
            acc[year][month][day] = [];
          }

          const hexToRgbString = (hex) => {
            const hexToRgb = (h) => {
              let r = 0,
                g = 0,
                b = 0;

              // 3 digits
              if (h.length === 4) {
                r = "0x" + h[1] + h[1];
                g = "0x" + h[2] + h[2];
                b = "0x" + h[3] + h[3];
                // 6 digits
              } else if (h.length === 7) {
                r = "0x" + h[1] + h[2];
                g = "0x" + h[3] + h[4];
                b = "0x" + h[5] + h[6];
              }
              return `rgba(${+r}, ${+g}, ${+b}, 0.65)`;
            };
            return hexToRgb(hex);
          };
          event.startString = new Date(event.start).toLocaleTimeString(
            this.$i18n.locale,
            {
              hour: "2-digit",
              minute: "2-digit",
            }
          );

          event.endString = new Date(event.end).toLocaleTimeString(
            this.$i18n.locale,
            {
              hour: "2-digit",
              minute: "2-digit",
            }
          );
          event.selectedDay = new Date(event.start).toLocaleDateString(
            this.$i18n.locale,
            {
              weekday: "short",
              day: "numeric",
              month: "short",
            }
          );
          event.selectedEndDay = new Date(event.end).toLocaleDateString(
            this.$i18n.locale,
            {
              weekday: "short",
              day: "numeric",
              month: "short",
            }
          );
          event.rgba = hexToRgbString(event.backgroundColor);

          acc[year][month][day].push(event);
          return acc;
        }, {});
      }
      this.isLoadingData = false;
    } catch (e) {
      console.error(e);
    } finally {
      // this.isLoadingData = false;
      // console.log(this.loadedEvents);
    }
  },
  methods: {
    formatDateHeader(year, month, day) {
      return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString(
        this.$i18n.locale,
        {
          weekday: "short",
          day: "numeric",
          month: "long",
        }
      );
    },
    onReady() {
      // console.log("ready");
    },
    goToToday() {
      const today = new Date();
      const day = today.getDay();

      const mondayOfCurrentWeek = new Date(today);
      const diffToMonday = day === 0 ? -6 : 1 - day; // If Sunday (0), go back 6 days
      mondayOfCurrentWeek.setDate(today.getDate() + diffToMonday);
      mondayOfCurrentWeek.setHours(0, 0, 0, 0);

      const sundayOfCurrentWeek = new Date(mondayOfCurrentWeek);
      sundayOfCurrentWeek.setDate(mondayOfCurrentWeek.getDate() + 6);
      sundayOfCurrentWeek.setHours(23, 59, 59, 999);

      this.startDate = mondayOfCurrentWeek.toISOString();
      this.endDate = sundayOfCurrentWeek.toISOString();
      this.$fetch();
    },
    previousWeek() {
      const currentStart = new Date(this.startDate);
      const currentEnd = new Date(this.endDate);

      currentStart.setDate(currentStart.getDate() - 7);
      currentStart.setHours(0, 0, 0, 0);
      currentEnd.setDate(currentEnd.getDate() - 7);
      currentEnd.setHours(23, 59, 59, 999);

      this.startDate = currentStart.toISOString();
      this.endDate = currentEnd.toISOString();
      this.$fetch();
    },
    nextWeek() {
      const currentStart = new Date(this.startDate);
      const currentEnd = new Date(this.endDate);

      currentStart.setDate(currentStart.getDate() + 7);
      currentStart.setHours(0, 0, 0, 0);
      currentEnd.setDate(currentEnd.getDate() + 7);
      currentEnd.setHours(23, 59, 59, 999);

      this.startDate = currentStart.toISOString();
      this.endDate = currentEnd.toISOString();
      this.$fetch();
    },
    previousMonth() {
      const currentStart = new Date(this.startDate);
      const currentEnd = new Date(this.endDate);

      currentStart.setMonth(currentStart.getMonth() - 1);
      currentEnd.setMonth(currentEnd.getMonth() - 1);

      this.startDate = currentStart.toISOString();
      this.endDate = currentEnd.toISOString();
      this.$fetch();
    },
    nextMonth() {
      const currentStart = new Date(this.startDate);
      const currentEnd = new Date(this.endDate);

      currentStart.setMonth(currentStart.getMonth() + 1);
      currentEnd.setMonth(currentEnd.getMonth() + 1);

      this.startDate = currentStart.toISOString();
      this.endDate = currentEnd.toISOString();
      this.$fetch();
    },
    openEvt(event) {
      this.$router.push({
        path: this.localePath(`/event/${event.id}`),
      });
    },
    computeCol(evt) {
      // event.featured ? 2 : 1
      // console.log(evt);
      // check if window is present
      if (process.client && window) {
        const width = window.innerWidth;
        if (evt.featured) {
          if (width > 1560) {
            return 4;
          } else if (width > 1280) {
            return 3;
          } else if (width > 960) {
            return 3;
          } else if (width > 560) {
            return 2;
          } else {
            return 1;
          }
        } else {
          if (width > 1560) {
            return 1;
          } else if (width > 1280) {
            return 1;
          } else if (width > 960) {
            return 1;
          } else if (width > 560) {
            return 1;
          } else {
            return 1;
          }
        }
      } else {
        return 1;
      }
    },

    enterAnimation() {
      const anime = this.$anime;
      anime({
        targets: ".main-content",
        easing: "easeInOutQuad",
        opacity: [0, 1],
        filter: ["blur(2rem)", "blur(0px)"],
        duration: 360,
      });
    },
  },
};
</script>
